<template>
  <div class="fg-game">
    <loading-state :state="state"></loading-state>
    <div v-if="state.isLoaded()" class="content">
      <game-head :preview="preview"></game-head>
      <div class="game-info" v-if="!preview.game.is_closed">
        <div class="closetime">
          <span>Game participation close at</span>
          <b class="blinking">{{preview.game.closesAt | relativeShortDateTime}}</b>
        </div>

        <div class="call-to-action" v-if="!preview.game.is_closed">
          <router-link v-if="preview.my_participation" class="clean call-to-action" :to="{ name: 'FGGamePlay', params:{contestKey: preview.contest.key, gameKey: preview.game.key}}">
            Edit Team
          </router-link>
          <router-link v-else class="clean call-to-action play-btn" :to="{ name: 'FGGamePlay', params:{contestKey: preview.contest.key, gameKey: preview.game.key}}">
            <span v-if="contest">
              <span class="free" v-if="contest.rule.buy_in_chips === 0">Free</span>
              <span v-else>{{contest.rule.buy_in_chips}}$</span>
            </span>
            Play
          </router-link>
        </div>

      </div>
      <div class="game-content">
        <div class="matches">
          <svg-icon icon-name="game" class="game-icon head-icon"></svg-icon>
          <div class="matches card inv">
            <div
              v-for="match in preview.matches"
              :key="match.match.key"
              class="match-mini"
            >
              <a class="clean" :href="match.match.link" target="window">
                <div class="teams">
                  <div class="team">{{match.match.teamAName}}</div>
                  <div class="team">{{match.match.teamBName}}</div>
                </div>
              </a>
              <div class="info">
                <b class="time">{{match.match.startAt | relativeShortDateTime}}</b>
                <p class="subtitle silent">{{match.match.subtitle}}</p>
                <p class="subtitle silent">{{match.match.season_name}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="participants">
          <svg-icon icon-name="pointsystem" class="participants-icon head-icon"></svg-icon>
          <div class="participants-list card inv">
            <ParticipantsPreview :preview="preview" @participantClick="onParticipantClick"/>
          </div>
        </div>
      </div>
      <div class="game-content" v-if="preview.game.is_closed">
        <div class="content-game-points">
          <GamePoints :gameKey="gameKey" />
        </div>

        <div class="game-team my-team" v-if="preview.my_team">
          <div>
            <GameTeam
              :gamePoints.sync="gamePoints"
              :gameKey="gameKey"
              :teamKey="preview.my_team.key"
              :popup="false"/>
          </div>
        </div>
      </div>
      <GameTeam
        :gamePoints.sync="gamePoints"
        :gameKey="gameKey"
        :teamKey="gamePopupTeamKey"
        :popupState.sync="gamePopupState"/>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePreview } from '@/models/fantasygame/core'
import GameHead from '@/components/fantasygame/GameHead'
import ParticipantsPreview from '@/components/fantasygame/ParticipantsPreview'
import GamePoints from '@/components/fantasygame/GamePoints'
import GameTeam from '@/components/fantasygame/GameTeam'

export default {
  components: {
    GameHead,
    ParticipantsPreview,
    GamePoints,
    GameTeam
  },

  data () {
    return {
      contestKey: this.$route.params.contestKey,
      gameKey: this.$route.params.gameKey,
      gamePoints: {},
      gamePopupTeamKey: null,
      gamePopupState: {
        show: false
      },
      preview: null,
      contest: null,
      state: DataState.newLoading(),
      contestState: DataState.newNotInit()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.gameKey !== from.params.gameKey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },

  mounted () {
    this.onViewOpenned()
  },

  methods: {
    onViewOpenned () {
      this.contestKey = this.$route.params.contestKey
      this.gameKey = this.$route.params.gameKey

      GamePreview.fetch(this.gameKey).then((resp) => {
        this.preview = resp
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    prepareToReopen () {
      this.preview = null
      this.contest = null
      this.state = DataState.newLoading()
      this.contestState = DataState.newNotInit()
    },

    refreshView () {

    },

    onParticipantClick (participant) {
      if (participant.user_team_key) {
        this.popupGameTeam(participant.user_team_key)
      }
    },

    popupGameTeam (teamKey) {
      this.gamePopupTeamKey = teamKey
      this.gamePopupState.show = true
    }
  }
}
</script>
